import { isAdminPortal } from '@/services/tenantValidation';

/**
 * Tenant JWT + ping + feature gates apply only to customer/tenant routes.
 * Platform admin uses platform_token and checkPlatformAccess — not this guard.
 */
export function shouldApplyTenantSessionGuard(to) {
  if (!to.meta?.requiresAuth) {
    return false;
  }
  if (to.meta?.requiresPlatformAdmin === true) {
    return false;
  }
  const path = to.path || '';
  if (path.startsWith('/platform')) {
    return false;
  }
  if (typeof window !== 'undefined' && isAdminPortal()) {
    return false;
  }
  return true;
}
